import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { mapCustomerClassifications } from '@mews-commander/utils';
import ClassificationIcon from './ClassificationIcon';

interface Props {
    classifications?: number | null;
}

export const ClassificationIcons = ({ classifications }: Props) => (
    <>
        {pipe(
            classifications,
            mapCustomerClassifications,
            array.map((c) => <ClassificationIcon key={c.value} classification={c} />)
        )}
    </>
);
